import { supabase } from "@/integrations/supabase/client";
import { SESSION_EXPIRED_DESCRIPTION } from "@/lib/authSessionError";
import { toast } from "sonner";

/**
 * Tear down a session the server no longer accepts.
 *
 * Scope is `local`: the refresh token is already gone server-side (that's why
 * we're here), so a global sign-out would just fail with another 401. Clearing
 * locally fires `onAuthStateChange('SIGNED_OUT')`, which drops the React Query
 * caches and lets the route guards send the user to the login page — instead
 * of leaving them stranded on /upgrade.
 *
 * Safe to call from several places at once: concurrent calls collapse onto the
 * same promise so the user sees one toast, not one per failed request.
 */
let inFlight: Promise<void> | null = null;

export function endExpiredSession(): Promise<void> {
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      toast.error(SESSION_EXPIRED_DESCRIPTION);
      await supabase.auth.signOut({ scope: "local" });
    } finally {
      // Allow a later, genuinely new expiry to be handled again.
      inFlight = null;
    }
  })();

  return inFlight;
}
